export const LIST = "list"
export const NOT_COMPLETED = "not_completed"
export const COMPLETED = "completed"
export const CALENDAR = "calendar"
